import React, {useEffect, useState} from 'react';
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_PINTEREST_DASHBOARD_TAB,
    PINTEREST_DASHBOARD_TABS_LIST,
    PINTEREST_SCOPES
} from "../../constants/pinterest.constant";
import DesignInfoList from "../design-info/design-info-list";
import PinterestPinSyncList from "../pinterest-pin-sync/pinterest-pin-sync-list";
import {SHOPIFY_KEYS} from "../../../shopify/constants/shopify.constant";
import {getDataFromLocalStorage, setDataInLocalStorage} from "../../../common/utils/local-storage-util";
import _ from "lodash";
import {auth, pinterestConfig} from "../../../firebase/client-app";
import {useLocation, useParams} from "react-router-dom";
import queryString from 'query-string';
import {getPinterestAccessToken, initPinterestOAuth} from "../../utils/pinterest-oauth-util";
import PinterestAccountsList from "../pinterest-account/pinterest-account-list";
import PinterestBoardsList from "../pinterest-board/pinterest-board-list";
import PinterestPinsList from "../pinterest-pin/pinterest-pin-list";
import {fetchPinterestAccessToken, fetchPinterestUserAccount} from "../../services/pinterest-api-service";
import {getPinterestAccountsForCurrentUser} from "../../services/pinterest-account-data.service";
import RenderFields from "../../../common/ui/render-fields";
import SelectPinterestAccount from "../pinterest-account/select-pinterest-account";


const tabsList = PINTEREST_DASHBOARD_TABS_LIST;

const PinterestDashboard = () => {
    const location = useLocation();
    const {code} = queryString.parse(location.search);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_PINTEREST_DASHBOARD_TAB);
    const [initialStep, setInitialStep] = useState(true);
    const [pinterestAccountsList, setPinterestAccountsList] = useState(null);
    const [selectedPinterestAccount, setSelectedPinterestAccount] = useState(null);

    useEffect(() => {
        if (initialStep) {
            init();
            getPinterestAccounts();
            setInitialStep(false);
        }
    }, [initialStep]);

    useEffect(() => {
        if (code) {
            // getPinterestAccount();
            handleOAuthRedirect();
        }
    }, [code]);

    const init = async () => {
        const existingSelectedTab = getDataFromLocalStorage(SHOPIFY_KEYS.SELECTED_TAB);

        if (existingSelectedTab) {
            setSelectedTab(existingSelectedTab);
        }
    }

    useEffect(() => {
        if (!_.isEmpty(selectedTab)) {
            setDataInLocalStorage(SHOPIFY_KEYS.SELECTED_TAB, selectedTab);
        }
    }, [selectedTab]);

    const initiateLoginToPinterest = () => {
        initPinterestOAuth();
    }

    const handleOAuthRedirect = async () => {
        const {data, error} = await fetchPinterestAccessToken(code);
        await getPinterestAccounts();
    }

    const getPinterestAccounts = async () => {
        const pinterestUserAccountsResult = await getPinterestAccountsForCurrentUser();
        setPinterestAccountsList(pinterestUserAccountsResult);
        setSelectedPinterestAccount(pinterestUserAccountsResult[0]);
    }

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start p-4 w-full">
                    <div className="flex justify-start items-center m-2 pb-2">
                        <div className="text-xl mr-4">
                            Pinterest
                        </div>

                        <div className={'flex justify-between items-center w-full'}>
                            <ShowTabsList
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                tabsList={tabsList}/>

                            <div className={'mr-2 flex justify-between items-center w-fit'}>
                                {pinterestAccountsList && pinterestAccountsList.length > 0 &&
                                    <div className={'mx-2'}>
                                        <SelectPinterestAccount
                                            selectedPinterestAccount={selectedPinterestAccount}
                                            setSelectedPinterestAccount={setSelectedPinterestAccount}
                                            pinterestAccountsList={pinterestAccountsList}/>
                                    </div>
                                }

                                <button
                                    onClick={initiateLoginToPinterest}
                                    className="button-pink px-2 py-1">
                                    Login to Pinterest
                                </button>
                            </div>
                        </div>
                    </div>


                    <div className="justify-center">

                        <div className="justify-start pb-4">

                            {!initialStep &&

                                <div className="px-4">

                                    {selectedTab?.key === 'designs' &&
                                        <div>
                                            <DesignInfoList pinterestAccount={selectedPinterestAccount}/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'pinterestSyncs' &&
                                        <div>
                                            <PinterestPinSyncList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'pinterestAccounts' &&
                                        <div>
                                            <PinterestAccountsList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'pinterestBoards' &&
                                        <div>
                                            <PinterestBoardsList pinterestAccount={selectedPinterestAccount}/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'pinterestPins' &&
                                        <div>
                                            <PinterestPinsList/>
                                        </div>
                                    }


                                </div>

                            }

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default PinterestDashboard
